<app-hero-banner [title]="'PARTNER PORTAL REGISTRATION'"></app-hero-banner>
<p class="w-half text-center text-base mb-12 mt-12">
  {{stepperMessage}}
</p>
@if (!selectedType) {
  <div class="mt-8 pointer-events-auto">
    <ng-container *ngTemplateOutlet="personalInfoTemplate"></ng-container>
  </div>
}
<app-load-spinner-wrapper [loading]="loading">
  @if (selectedType) {
    <mat-horizontal-stepper #stepper [linear]="true" class="pointer-events-none registration-custom-stepper">
      <ng-template matStepperIcon="number">
        <mat-icon>circle</mat-icon>
      </ng-template>
      <ng-template matStepperIcon="edit">
        <mat-icon>circle</mat-icon>
      </ng-template>
      <ng-template matStepperIcon="done">
        <mat-icon>check</mat-icon>
      </ng-template>
      <ng-template matStepperIcon="editondone">
        <mat-icon>check</mat-icon>
      </ng-template>
      <mat-step label="Personal Info" [state]="stepCompleted[0] ? 'editondone' : 'number'" [completed]="stepCompleted[0]">
        <div class="mt-8">
          <ng-container *ngTemplateOutlet="personalInfoTemplate"></ng-container><br>
          <ng-container *ngTemplateOutlet="securityInfoTemplate"></ng-container>
        </div>
      </mat-step>
      <mat-step label="Company Info" [state]="stepCompleted[1] ? 'editondone' : 'number'" [completed]="stepCompleted[1]">
        <div class="mt-8">
          <ng-container *ngTemplateOutlet="companyInfoTemplate"></ng-container>
        </div>
      </mat-step>
      @if (selectedType === UserAccountTypes.REFERRAL_PARTNER) {
        <mat-step label="Clinic & Provider Info" [completed]="stepCompleted[2]">
          <div class="mt-8">
            <ng-container *ngTemplateOutlet="clinicProviderInfoTemplate"></ng-container>
          </div>
        </mat-step>
      }
      <mat-step label="Thank You" [state]="stepCompleted[3] ? 'editondone' : 'number'" [completed]="stepCompleted[3]">
        <div class="mt-8">
          <ng-container *ngTemplateOutlet="thankYouTemplate"></ng-container>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  }
  @if (selectedType) {
    <div class="mt-12 pb-12">
      @if (currentStep === 0) {
        <app-mat-stepper-navigation
          [buttonOneTitle]="'Cancel'"
          [buttonThreeTitle]="'Next >'"
          (onButtonOneClick)="onCancel()"
          (onButtonThreeClick)="handleNext()"
          >
        </app-mat-stepper-navigation>
      }
      @if (selectedType === UserAccountTypes.REFERRAL_PARTNER && currentStep === 1) {
        <app-mat-stepper-navigation
          [buttonOneTitle]="'< Back'"
          [buttonTwoTitle]="'Cancel'"
          [buttonThreeTitle]="'Next >'"
          (onButtonOneClick)="goBack()"
          (onButtonTwoClick)="onCancel()"
          (onButtonThreeClick)="handleNext()"
          >
        </app-mat-stepper-navigation>
      }
      @if ((selectedType === UserAccountTypes.REFERRAL_PARTNER && currentStep === 2) || (selectedType !== UserAccountTypes.REFERRAL_PARTNER && currentStep === 1)) {
        <app-mat-stepper-navigation
          [buttonOneTitle]="'< Back'"
          [buttonTwoTitle]="'Cancel'"
          [buttonThreeTitle]="'Register'"
          (onButtonOneClick)="goBack()"
          (onButtonTwoClick)="onCancel()"
          (onButtonThreeClick)="startProcessToRegisterUser()"
          >
        </app-mat-stepper-navigation>
      }
    </div>
  }
</app-load-spinner-wrapper>


<ng-template #personalInfoTemplate>
  <p class="text-xl mb-2">Personal Information</p>
  <app-hr></app-hr>
  <form [formGroup]="piForm" class="flex flex-wrap gap-4 mt-4 pointer-events-auto">
    <mat-form-field appearance="fill" class="w-full sm:w-[48%] lg:w-[32%] !mt-0">
      <mat-label>Choose Account Type</mat-label>
      <mat-select [(ngModel)]="selectedType" formControlName="accountType">
        @for (pitype of personalInfoTypes; track pitype) {
          <mat-option [value]="pitype.value">{{pitype.label}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (selectedType) {
      <mat-form-field class="w-full sm:w-[48%] lg:w-[32%] !mt-0" appearance="fill">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName">
        @if (stepSubmitted[0] && piForm.get('firstName')?.hasError('required')) {
          <mat-error>
            First Name is required.
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="w-full sm:w-[48%] lg:w-[32%] !mt-0" appearance="fill">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName">
        @if (stepSubmitted[0] && piForm.get('lastName')?.hasError('required')) {
          <mat-error>
            Last Name is required.
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="w-full sm:w-[48%] lg:w-[32%] !mt-0" appearance="fill">
        <mat-label>Email Address</mat-label>
        <input matInput type="email" formControlName="email">
        @if (stepSubmitted[0] && piForm.get('email')?.hasError('required')) {
          <mat-error>
            Email is required.
          </mat-error>
        }
        @if (stepSubmitted[0] && piForm.get('email')?.hasError('emailTaken')) {
          <mat-error>
            Email is not available.
          </mat-error>
        }
        @if (stepSubmitted[0] && piForm.get('email')?.hasError('email')) {
          <mat-error>
            Please enter a valid email.
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="w-full sm:w-[48%] lg:w-[32%] !mt-0" appearance="fill">
        <mat-label>Phone Number</mat-label>
        <input matInput mask="(000) 000-0000" formControlName="phone">
        @if (stepSubmitted[0] && piForm.get('phone')?.hasError('required')) {
          <mat-error>
            Phone number is required.
          </mat-error>
        }
        @if (stepSubmitted[0] && piForm.get('phone')?.hasError('mask')) {
          <mat-error>
            Invalid phone number format.
          </mat-error>
        }
      </mat-form-field>
      @if (selectedType === UserAccountTypes.REFERRAL_PARTNER) {
        <mat-form-field class="w-full sm:w-[48%] lg:w-[32%] !mt-0" appearance="fill">
          <mat-label>Job Title</mat-label>
          <input matInput formControlName="jobTitle">
          @if (stepSubmitted[0] && piForm.get('jobTitle')?.hasError('required')) {
            <mat-error>
              Job title is required.
            </mat-error>
          }
        </mat-form-field>
      }
      @if (selectedType !== UserAccountTypes.REFERRAL_PARTNER) {
        <mat-form-field class="w-full sm:w-[48%] lg:w-[32%] !mt-0" appearance="fill">
          <mat-label>Fax Number</mat-label>
          <input matInput mask="(000) 000-0000" formControlName="fax">
          @if (stepSubmitted[0] && piForm.get('fax')?.hasError('mask')) {
            <mat-error>
              Invalid fax number format.
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="w-full sm:w-[48%] lg:w-[32%] !mt-0" appearance="fill">
          <mat-label>Street Address</mat-label>
          <input matInput formControlName="street">
          @if (stepSubmitted[0] && piForm.get('street')?.hasError('required')) {
            <mat-error>
              Street address is required.
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="w-full sm:w-[48%] lg:w-[32%] !mt-0" appearance="fill">
          <mat-label>City</mat-label>
          <input matInput formControlName="city">
          @if (stepSubmitted[0] && piForm.get('city')?.hasError('required')) {
            <mat-error>
              City is required.
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="w-full sm:w-[48%] lg:w-[32%] !mt-0" appearance="fill">
          <mat-label>State</mat-label>
          <mat-select formControlName="state">
            @for (state of us_states_list; track state) {
              <mat-option [value]="state.value">{{state.label}}</mat-option>
            }
          </mat-select>
          @if (stepSubmitted[0] && piForm.get('state')?.hasError('required')) {
            <mat-error>
              State is required.
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="w-full sm:w-[48%] lg:w-[32%] !mt-0" appearance="fill">
          <mat-label>Zip Code</mat-label>
          <input
            matInput
            maxlength="5"
            formControlName="zipcode"
            type="text"
            inputmode="numeric"
            pattern="\d*"
            mask="00000"
            >
          @if (stepSubmitted[0] && piForm.get('zipcode')?.hasError('required')) {
            <mat-error>
              Zip code is required.
            </mat-error>
          }
          @if (stepSubmitted[0] && piForm.get('zipcode')?.hasError('pattern')) {
            <mat-error>
              Zip code must be 5 digits.
            </mat-error>
          }
        </mat-form-field>
      }
    }
  </form>
</ng-template>

<ng-template #securityInfoTemplate>
  <p class="text-xl mb-2">Security Information</p>
  <app-hr></app-hr>
  <form [formGroup]="siForm" class="flex flex-wrap gap-4 mt-4 pointer-events-auto">
    <mat-form-field class="w-full sm:w-[48%] lg:w-[32%] !mt-0" appearance="fill">
      <mat-label>Password</mat-label>
      <input matInput type="password" formControlName="password">
      @if (stepSubmitted[0] && siForm.get('password')?.hasError('required')) {
        <mat-error>
          Password is required.
        </mat-error>
      }
      @if (stepSubmitted[0] && siForm.get('password')?.hasError('passwordPolicy')) {
        <mat-error>
          Min 10 chars, with upper, lower, number & symbol.
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field class="w-full sm:w-[48%] lg:w-[32%] !mt-0" appearance="fill">
      <mat-label>Confirm Password</mat-label>
      <input matInput type="password" formControlName="confirmPassword">
      @if (stepSubmitted[0] && siForm.get('confirmPassword')?.hasError('required')) {
        <mat-error>
          Confirm password is required.
        </mat-error>
      }
      @if (stepSubmitted[0] && siForm.get('confirmPassword')?.hasError('passwordMismatch')) {
        <mat-error>
          Passwords do not match.
        </mat-error>
      }
    </mat-form-field>
  </form>
</ng-template>

<ng-template #companyInfoTemplate>
  <p class="text-xl mb-2">Company Information</p>
  <app-hr></app-hr>
  <form [formGroup]="ciForm" class="pointer-events-auto">
    @if (selectedType) {
      <p class="text-lg mt-8">Manager's Information</p>
      <div class="flex flex-wrap gap-4 mt-4">
        <mat-form-field class="w-full sm:w-[48%] lg:w-[32%] !mt-0" appearance="fill">
          <mat-label>First Name</mat-label>
          <input matInput formControlName="managerFirstName">
          @if (stepSubmitted[1] && ciForm.get('managerFirstName')?.hasError('required')) {
            <mat-error>
              First Name is required.
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="w-full sm:w-[48%] lg:w-[32%] !mt-0" appearance="fill">
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="managerLastName">
          @if (stepSubmitted[1] && ciForm.get('managerLastName')?.hasError('required')) {
            <mat-error>
              Last Name is required.
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="w-full sm:w-[48%] lg:w-[32%] !mt-0" appearance="fill">
          <mat-label>Email Address</mat-label>
          <input matInput type="email" formControlName="managerEmail">
          @if (stepSubmitted[1] && ciForm.get('managerEmail')?.hasError('required')) {
            <mat-error>
              Email is required.
            </mat-error>
          }
          @if (stepSubmitted[1] && ciForm.get('managerEmail')?.hasError('email')) {
            <mat-error>
              Please enter a valid email.
            </mat-error>
          }
        </mat-form-field>
      </div>
      <p class="text-lg mt-8">Contact Information</p>
      <div class="flex flex-wrap gap-4 mt-4">
        @if (selectedType !== UserAccountTypes.REFERRAL_PARTNER) {
          <mat-form-field class="w-full sm:w-[48%] lg:w-[32%] !mt-0" appearance="fill">
            <mat-label>Company Name</mat-label>
            <input matInput formControlName="companyName">
            @if (stepSubmitted[1] && ciForm.get('companyName')?.hasError('required')) {
              <mat-error>
                Company Name is required.
              </mat-error>
            }
          </mat-form-field>
        }
        <mat-form-field class="w-full sm:w-[48%] lg:w-[32%] !mt-0" appearance="fill">
          <mat-label>Fax # for Information</mat-label>
          <input matInput mask="(000) 000-0000" formControlName="faxForInformation">
          @if (stepSubmitted[1] && ciForm.get('faxForInformation')?.hasError('required')) {
            <mat-error>
              Fax number for information is required.
            </mat-error>
          }
          @if (stepSubmitted[1] && ciForm.get('faxForInformation')?.hasError('mask')) {
            <mat-error>
              Invalid fax number format.
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="w-full sm:w-[48%] lg:w-[32%] !mt-0" appearance="fill">
          <mat-label>Fax # for Chart note</mat-label>
          <input matInput mask="(000) 000-0000" formControlName="faxForChartNote">
          @if (stepSubmitted[1] && ciForm.get('faxForChartNote')?.hasError('required')) {
            <mat-error>
              Fax number for chart note is required.
            </mat-error>
          }
          @if (stepSubmitted[1] && ciForm.get('faxForChartNote')?.hasError('mask')) {
            <mat-error>
              Invalid fax number format.
            </mat-error>
          }
        </mat-form-field>
      </div>
      @if (selectedType !== UserAccountTypes.REFERRAL_PARTNER) {
        <div>
          <mat-checkbox class="acceptPrivacyPolicyAndTermsCheckbox" formControlName="acceptedPrivacyPolicyAndTermsOfUse">
            <p>Do you accept the
              <a href="{{privacyPolicyUrl}}" target="_blank" class="underline">Privacy Policy</a> and the
              <a href="{{termsOfUseUrl}}" target="_blank" class="underline">Terms of Use</a>?
            </p>
          </mat-checkbox>
          @if (stepSubmitted[1] && ciForm.get('acceptedPrivacyPolicyAndTermsOfUse')?.hasError('required')) {
            <mat-error>
              You must accept Privacy Policy and the Terms of Use to continue.
            </mat-error>
          }
        </div>
      }
    }
  </form>
</ng-template>

<ng-template #clinicProviderInfoTemplate>
  <p class="text-xl mb-2">Choose Clinics and Providers</p>
  <app-hr></app-hr>
  <form [formGroup]="cpInfoForm">
    <div class="flex flex-wrap gap-4 mt-4 pointer-events-auto mb-8">
      <div class="w-full sm:w-[48%] lg:w-[49%] !mt-0 flex flex-col gap-y-4">
        <app-clinic-search-dropdown
          [required]="true"
          [dropdownLabel]="'Select First Clinic'"
          [dropdownSelectionFormControl]="firstClinicCtrl"
          [showError]="stepSubmitted[2]"
          >
        </app-clinic-search-dropdown>
        <app-provider-multiselect
          [required]="true"
          [label]="'Select Providers'"
          [selectionFormControl]="firstProvidersCtrl"
          [otherProviderNameFormControl]="firstClinicOtherProviderNameCtrl"
          [otherProviderNPIFormControl]="firstClinicOtherProviderNPICtrl"
          [showError]="stepSubmitted[2] && !!firstClinicCtrl.value"
          [clinicId]="firstClinicCtrl.value"
          [showRequestRemovalClinicOption]="false"
          >
        </app-provider-multiselect>
      </div>
      <div class="w-full sm:w-[48%] lg:w-[49%] !mt-8 sm:!mt-0 flex flex-col gap-y-4">
        <app-clinic-search-dropdown
          [required]="false"
          [dropdownLabel]="'Select Second Clinic'"
          [dropdownSelectionFormControl]="secondClinicCtrl"
          [showError]="false"
          >
        </app-clinic-search-dropdown>
        <app-provider-multiselect
          [required]="!!secondClinicCtrl.value"
          [label]="'Select Providers'"
          [selectionFormControl]="secondProvidersCtrl"
          [otherProviderNameFormControl]="secondClinicOtherProviderNameCtrl"
          [otherProviderNPIFormControl]="secondClinicOtherProviderNPICtrl"
          [showError]="stepSubmitted[2]"
          [clinicId]="secondClinicCtrl.value"
          [showRequestRemovalClinicOption]="false"
          >
        </app-provider-multiselect>
      </div>
    </div>
    <div class="pointer-events-auto">
      <mat-checkbox class="acceptPrivacyPolicyAndTermsCheckbox" formControlName="referralUserAcceptedPrivacyPolicyAndTermsOfUse">
        <p>Do you accept the
          <a href="{{privacyPolicyUrl}}" target="_blank" class="underline">Privacy Policy</a> and the
          <a href="{{termsOfUseUrl}}" target="_blank" class="underline">Terms of Use</a>?
        </p>
      </mat-checkbox>
      @if (stepSubmitted[2] && cpInfoForm.get('referralUserAcceptedPrivacyPolicyAndTermsOfUse')?.hasError('required')) {
        <mat-error>
          You must accept Privacy Policy and the Terms of Use to continue.
        </mat-error>
      }
    </div>
  </form>
</ng-template>

<ng-template #thankYouTemplate>
  <p class="text-xl mb-2">Thank You!</p>
  <app-hr></app-hr>
  <p class="mt-4 mb-12 text-base">
    We will be reaching out to you soon. Please check your spam folder if you don’t see an email.
  </p>
  <div class="pointer-events-auto">
    <app-mat-stepper-navigation
      [buttonThreeTitle]="'Return to Iowa Ortho Website'"
      (onButtonThreeClick)="returnToIowaOrthoWebsite()"
      >
    </app-mat-stepper-navigation>
  </div>
</ng-template>
